import { render, staticRenderFns } from "./historicoSellOut.vue?vue&type=template&id=3d6dcf79"
import script from "./historicoSellOut.vue?vue&type=script&lang=js"
export * from "./historicoSellOut.vue?vue&type=script&lang=js"
import style0 from "./historicoSellOut.vue?vue&type=style&index=0&id=3d6dcf79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports